export default __webpack_public_path__ + "static/media/mail-active.554523fb.svg";